import { Link } from '@inertiajs/react'
import { useCart } from './cart'
import { formatLempiras } from './format'

interface CartHeaderProps {
  slug: string
  accountName: string
  logoUrl?: string | null
}

/**
 * Reusable header for every public-catalog page. Shows the account name,
 * a link back to the catalog, and a live cart button with item count + total.
 *
 * Every page that wraps the customer-facing catalog (Index, Show, Cart,
 * Checkout, Thanks) should render this so the cart count stays in sync.
 */
export default function CartHeader({ slug, accountName, logoUrl }: CartHeaderProps) {
  const { count, totalCents, totalWithTax } = useCart()

  return (
    <header className="bg-[#202020] text-white sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <Link href={`/${slug}/catalog`} className="flex items-center gap-2 font-bold text-lg">
          {logoUrl && <img src={logoUrl} className="h-8 w-8 object-contain bg-white rounded" />}
          {accountName}
        </Link>
        <div className="flex items-center gap-3">
          <Link href={`/${slug}/catalog/upload-proof`} className="text-sm text-gray-300 hover:text-white transition-colors">
            📎 Subir comprobante
          </Link>
          <Link
            href={`/${slug}/catalog/cart`}
            className="relative bg-[#FFC107] text-[#202020] px-3 py-1.5 rounded font-semibold text-sm flex items-center gap-2 hover:bg-[#e6ad06] transition-colors"
          >
            <span>🛒 Carrito</span>
            {count > 0 && (
              <span className="bg-[#202020] text-white text-xs font-bold rounded-full min-w-[1.5rem] h-6 px-1.5 flex items-center justify-center">
                {count}
              </span>
            )}
            {totalWithTax > 0 && (
              <span className="text-sm font-bold whitespace-nowrap">{formatLempiras(totalWithTax)}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  )
}
